<template>
  <div class="kye-edit-table">
    <el-table
      :max-height="tableMaxHeight"
      ref="multipleTable"
      :data="tData.data"
      :row-class-name="rowClassName"
      row-key="_uuid"
      :stripe="false"
      border
      :empty-text="toEmptyText"
      v-bind="$attrs"
      @header-dragend="headerDragend"
      @current-change="selectRow"
      @cell-click="cellClick"
      @sort-change="sortChange"
      @selection-change="selectionRow">
      <template slot="empty">
        <slot name="empty"></slot>
      </template>
      <el-table-column v-if="showCheckbox"
        :resizable="false"
        fixed
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column v-if="showIndex"
        :resizable="false"
        fixed
        type="index"
        label="序号"
        width="50">
      </el-table-column>
      <!-- 2022-09-01 提供query-table一样的operation -->
      <!-- <el-table-column
        v-if="operation"
        :resizable="false"
        :fixed="operation.fixed"
        :label="operation.label"
        :width="operation.width"
        >
          <template slot-scope="scope">
            <slot v-if="!operation.options.length" name="operation" :row="scope"></slot>
            <tool-list
              v-else
              :tools="operation.options"
              :wrapStyle="operation.wrapStyle"
              :active="operation.active"
            >
            </tool-list>
          </template>
      </el-table-column> -->
      <!-- 2022-09-01 使用handle不能固定列，还是能拖动，所以提供上面的方法 -->
      <slot name="handle"></slot>
      <!-- 2022-08-31 增加自定义renderHeader 可自定义画头部 -->
      <el-table-column
        v-for="(column, columnIndex) in columnConfig"
        v-if="showColumn(column, columnIndex)"
        :key="`${column.key}${columnIndex}`"
        :sortable="column.sortable"
        :fixed="column.fixed"
        :resizable="!column.fixed"
        :prop="column.key"
        :label="column.label"
        :width="column.fixed && column.width"
        :min-width="!column.fixed && column.width"
        :render-header="column.renderHeader ? column.renderHeader : renderHeader"
        :class-name="(column.type === 'text' || !column.type) ? 'kye-edit-table__column-bg' : ''"
      >
          <template slot-scope="scope">
            <span v-if="showCellRequired(column)" style="position:absolute;top:2px;left:2px;color:#ff5555;font-weight:600;">*</span>
            <edit-content
              :ref="`row_${scope.$index}${columnIndex}`"
              :trigger-event-manager="triggerEventManager"
              :row="scope.row"
              :style="showCellRequired(column) ? { paddingLeft: '6px' } : {}"
              :key="column.key"
              :column="column"
              :tIndex="scope.$index"
              :val="scope.row[column.key]"
              @selectChange="selectChange"
              @searchTipsSelect="searchTipsSelect"
              @searchTipsClose="searchTipsClose"
              @clearSelectEdit="clearSelectEdit"
              @inputChange="inputChange"
              @datetimeChange="datetimeChange"
              @decrypt="decrypt"
              @inputFoucs="inputFoucs"
              :class="addColumnClassName(column, scope)"
            />
          </template>
      </el-table-column>
      <slot name="handleRight"></slot>
    </el-table>
    <div v-if="pages">
      <el-pagination style="margin-top: 12px;"
        :disabled="disabledPagination"
        background
        @size-change="pageSizeChange"
        @current-change="pageCurrentChange"
        :page-size="pages.size"
        :total="pages.total"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :layout="$pagination.layout">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { differenceWith, isEqual, cloneDeep } from 'lodash'
  // import cellRender from './cell-render'
  // import tips from './tips'
  import hideDrop from 'public/mixins/hide-dropdown'
  import Schema from 'async-validator'
  import EditContent from './edit-form'
  // import toolList from './tool-list.vue'
  import { date, isEmpty } from 'public/utils'
  import { createPopover } from './popover'
  let popoverReferenceIOInstance = null
  const ustr = () => Math.random().toString(36).substr(3)
  const uuid = () => ustr() + ustr()
  const editClassReg = /input|select|picker|search|area/

  export default {
    name: 'kye-edit-table',
    mixins: [hideDrop],
    components: {
      // cellRender,
      // tips,
      EditContent,
      // toolList
    },
    props: {
      status: {
        type: String,
        default: 'add'
      },
      column: {
        type: Array,
        default () {
          return []
        }
      },
      data: {
        type: Array,
        default () {
          return []
        }
      },
      pages: Object,
      showIndex: {
        type: Boolean,
        default: false
      },
      operation: {
        type: Object,
      },
      showCheckbox: {
        type: Boolean,
        default: false
      },
      maxHeight: {
        type: [Number, String]
      },
      emptyText: {
        type: String
      },
      disabledPagination: { // 禁用分页器
        type: Boolean,
        default: false
      },
      autoValidateNextRowOfTrigger: {
        type: Boolean,
        default: false
      },
      useRuleTrigger: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        currentPage: 1,
        tData: {
          data: []
        },
        hIndex: 0, // 2022-08-01 弃用属性，为防止其他业务线通过实例拿此属性，暂不删除
        inputTimer: null,
        catchData: [],
        originData: [],
        columnConfig: [],
        showHeaderTip: false,
        headerTipStyle: {
          left: 0,
          top: 0,
          key: ''
        },
        headerTip: null,
        table: null,
        tipContent: '',
        currentRowErrorStack: {},
        currentRowErrorIndex: -1,
      }
    },
    mounted () {
      this.headerTip = this.$refs.headerTip
      this.table = this.$refs.multipleTable
      this.popoverManager = createPopover(popoverReferenceIOInstance, this)
      // 气泡的hooks监听
      this.popoverManager.lifeCycleHooks(this)
    },
    computed: {
      tableMaxHeight () {
        return this.maxHeight
      },
      rules () {
        let rules = {}
        this.columnConfig.forEach((t, i) => {
          if (t.rule) {
            rules[t.key] = cloneDeep(t.rule) // 防止引用被修改 如果 required是 function， 则会使用结果值
            // 2022-08-31 增加自定义校验规则，某些时候下面的规则不适用时可自定义
            // 2022-08-31 增加type为render的类型（即自定义组件的类型）校验自定义组件的规则
            let customRule = t.rule.customRule
            if (customRule) {
              rules[t.key] = customRule
              return
            }
            if (t.type === 'input-number') {
              if (Array.isArray(t.rule)) {
                rules[t.key][0].type = 'number'
                rules[t.key][0].transform = v => isEmpty(v) ? Number(undefined) : Number(v)
              } else {
                rules[t.key].type = 'number'
                rules[t.key].transform = v => isEmpty(v) ? Number(undefined) : Number(v)
              }
            } else if (t.type === 'date-picker') {
              const format = t.option ? t.option.valueFormat || 'YYYY-MM-DD' : ''
              if (Array.isArray(t.rule)) {
                rules[t.key][0].transform = v => date(v, format)
              } else {
                rules[t.key].transform = v => date(v, format)
              }
            } else if (t.filter && t.filter.type === 'lookup') {
              if (Array.isArray(t.rule)) {
                rules[t.key][0].transform = v => String(v)
              } else {
                rules[t.key].transform = v => String(v)
              }
            }
            // 2022-12-05 kye-edit-table rule中的required可以根据某个值动态配置
            if (t.rule.hasOwnProperty('required')) {
              if (typeof t.rule.required === 'function') {
                rules[t.key].required = t.rule.required()
              }
            }
          }
        })
        return rules
      },
      toEmptyText () {
        return this.emptyText ? this.emptyText : null
      },
      pageSizes() {
        const pageSizes = (this.pages && this.pages.pageSizes) || this.$pagination.pageSizes
        return pageSizes
      }
    },
    methods: {
      // column 增加类名配置
      addColumnClassName(column, scope) {
        const { $index, row } = scope
        return column.className ? typeof column.className === 'function' ? column.className(row, $index, scope) : column.className : ''
      },
      // 缓存数据
      toCatch (data) {
        let index = 0
        const tData = []
        const catchData = []
        this.originData = JSON.parse(JSON.stringify(data))
        for (let item of data) {
          if (this.status === 'edit') {
            item._type = 'edit'
          } else if (!item._type) {
            item._type = 'add'
          }
          if (!item._uuid) {
            item._uuid = uuid()
          }
          item._tIndex = index
          tData.push({ ...item })
          catchData.push({ ...item })
          index += 1
        }
        this.tData.data = tData
        this.catchData = catchData
      },
      // 选择行事件
      selectRow (row) {
        let obj = { ...row }
        let index = obj._tIndex
        this.$emit('selectRow', index, obj)
      },
      selectionRow (val) {
        let arr = val.map(item => ({ ...item }))
        arr.sort((old, fresh) => fresh._tIndex - old._tIndex)
        this.$emit('checkboxRow', arr)
      },
      // 添加
      addRow (item, type = 'push') {
        if (!['push', 'unshift'].includes(type)) {
          type = 'push'
        }
        let index = type === 'push' ? this.tData.data.length : 0
        if (this.status === 'edit') {
          item._type = 'edit'
        } else if (!item._type) {
          item._type = 'add'
        }
        item._isNew = true
        item._uuid = uuid()
        item._tIndex = index
        this.tData.data[type]({ ...item })
        this.catchData[type]({ ...item })
        this.changeIndex()
        this.popoverManager.popoverChangeOfAddRow()
      },
      // 插入数据
      insertRow(index, item) {
        if (this.status === 'edit') {
          item._type = 'edit'
        } else if (!item._type) {
          item._type = 'add'
        }
        item._isNew = true
        item._uuid = uuid()
        item._tIndex = index
        this.tData.data.splice(index, 0, { ...item })
        this.catchData.splice(index, 0, { ...item })
        this.changeIndex()
        this.popoverManager.popoverChangeOfAddRow()
      },
      // 编辑行
      editeRow (index) {
        this.tData.data[index]._type = 'edit'
      },
      // 保存数据
      async saveRow (index, row) {
        if (row._isNew) {
          row._isNew = false
        }
        Object.keys(row).forEach(item => {
          this.catchData[index][item] = this.tData.data[index][item]
        })
        this.tData.data[index]._type = 'add'
      },
      // 取消编辑
      cancelRow (index, row) {
        if (row._isNew) {
          this.delRow(index)
          return
        }
        Object.keys(row).forEach(item => {
          this.tData.data[index][item] = this.catchData[index][item]
        })
        this.tData.data[index]._type = 'add'
        this.popoverManager.removePopperOfValidateSuccess()
      },
      // 删除一行
      delRow (index) {
        this.tData.data.splice(index, 1)
        this.catchData.splice(index, 1)
        this.changeIndex()
        // 数据变化之后，气泡对应的更新
        this.popoverManager.popoverChangeOfDelRow()
      },
      // 页码改变
      pageSizeChange (size) {
        this.$emit('pageSize', size)
      },
      // 页码改变
      pageCurrentChange (page) {
        this.$emit('pageChange', page)
      },
      // 表单验证
      // validate (formName) {
      //   return new Promise((resolve, reject) => {
      //     this.$refs.editTableRule.validate((valid) => {
      //       if (valid) {
      //         resolve(true)
      //       } else {
      //         resolve(false)
      //       }
      //     })
      //   })
      // },
      validate (index, triggerKey) {
        const self = this
        // 获取校验规则，过滤掉trigger
        const descriptor = this.popoverManager.getScheamRules()
        const validator = new Schema(descriptor)
        const valid = (i) => {
          return new Promise((resolve, reject) => {
            validator.validate(self.tData.data[i], (errors, fields) => {
              // 自动校验下一行数据在有trigger的场景下 需要主动开启 没有trigger不自动触发
              this.popoverManager.validateNexOfTrigger({i, fields})
              if (errors) {
                this.popoverManager.validateErrorManager({i, errors, fields, triggerKey})
                resolve(false)
              } else {
                // 检验通过就销毁
                this.popoverManager.removePopperOfValidateSuccess()
                resolve(true)
              }
            })
          })
        }

        const returnPromise = (p) => {
          return new Promise((resolve, reject) => {
            resolve(p)
          })
        }

        const loop = async (arr) => {
          for (let t of arr) {
            let v = await valid(t._tIndex)
            if (!v) {
              return returnPromise(false)
            }
          }
          return returnPromise(true)
        }
        if (index !== undefined) {
          return valid(index)
        } else {
          let arr = self.tData.data.filter(k => k._type === 'edit')
          return loop(arr)
        }
      },
      getEditTableFrom () {
        return this.$refs.editTableRule
      },
      // 表头渲染
      renderHeader (h, { column, $index }) {
        let label = column.label || ''
        // let c = this.column[$index - this.hIndex]
        // 2022-08-01 动态渲染列，$index会发生改变，导致渲染问题
        let c = this.columnConfig.find(v => v.key === column.property)
        let isRender = false
        if (c && c.rule) {
          if (Array.isArray(c.rule)) {
            for (let obj of c.rule) {
              if (obj.required) {
                isRender = true
                break
              }
            }
          } else if (c.rule.required) {
            // 触摸响应式系统，更新校验样式
            isRender = this.rules[column.property].required
          }
        }
        // 单元格显示必填符号时，不显示表头必填
        if (c.hasOwnProperty('showCellRequired')) {
          isRender = false
        }

        const wrapperNode = (child = []) => {
          return h('span', child)
        }

        // 气泡配置
        const { width = '200', show, content, placement = 'top', trigger = 'hover', contentType = 'string', contentRender = null } = c.headerTipOption || {}
        let isShow = typeof show === 'function' ? show() : show
        let popoverData = {
           props: {
            width,
            trigger,
            placement
          }
        }
        let defaultChlild = ''
        if (contentType === 'string' && !contentRender) {
          popoverData.props.content = content
        } else {
          defaultChlild = typeof contentRender === 'function' ? contentRender(h, c) : content
        }

        const tipNode = isShow ? h('el-popover', popoverData, [
          h('span', {
            class: 'el-icon-question kye-edit-table-icon-style',
            slot: 'reference'
          }),
          defaultChlild
        ]) : ''
        const textNode = isRender ? h('span', {}, [
          h('i', { style: { color: '#ff5555', paddingRight: '3px' } }, '*'),
          label
        ]) : h('span', label)
        return wrapperNode([textNode, tipNode])
      },
      // 获取双向绑定的数据
      getData () {
        return this.tData.data
      },
      // 获取双向绑定真实的数据
      getRealData () {
        let data = JSON.parse(JSON.stringify(this.tData.data))
        return data.map(x => {
          delete x._type
          delete x._tIndex
          delete x._uuid
          delete x._isNew
          return x
        })
      },
      // 获取改变后的数据
      getDiffData () {
        return differenceWith(this.getRealData(), this.originData, isEqual)
      },
      // change index
      changeIndex () {
        if (this.tData.data.length > 0) {
          for (let i = 0, len = this.tData.data.length; i < len; i++) {
            this.tData.data[i]._tIndex = i
            this.catchData[i]._tIndex = i
          }
        }
      },
      toChangeStatus () {
        if (this.tData.data.length > 0) {
          for (let i = 0, len = this.tData.data.length; i < len; i++) {
            this.tData.data[i]._type = this.status
          }
        }
      },
      rowClassName ({ row }) {
        // TODO 因为使用render模式的部门很多，这里使用的兜底方式来做is-edit类添加
        const newEditMode = row._type === 'edit' && this.columnConfig.some(v => (v.type === 'render' && v.renderEdit === true))
        if ((row._type === 'edit' && this.columnConfig.some(v => editClassReg.test(v.type))) || newEditMode) {
          return 'is-edit'
        }
        return 'is-add'
      },
      headerDragend (newWidth, oldWidth, column, event) {
        for (const col of this.columnConfig) {
          if (col.key === column.property) {
            if (col.hasOwnProperty('width')) {
              col.width = newWidth
            } else {
              this.$set(col, 'width', newWidth)
            }
            break
          }
        }
      },
      rowClick (row, event, column) {
        if (this.showCheckbox) {
          this.$refs.multipleTable.toggleRowSelection(row)
        }
      },
      selectChange (prams) {
        const { index, val, column, data } = prams
        const prow = this.tData.data[index]
        prow[column.key] = val
        column.change && column.change(index, prow, data)
      },
      inputFoucs(prams, row) {
        const { index, column } = prams
        typeof column.foucs === 'function' && column.foucs(index, prams, row)
      },
      searchTipsSelect (val) {
        let { index, column, str, ids, data, tags } = val
        const prow = this.tData.data[index]
        prow[column.key] = str
        if (column.ids) {
          prow[column.ids] = ids
        }
        if (column.change) {
          column.change(index, prow, data, tags)
        }
      },
      searchTipsClose (val) {
        let { index, column, str, ids, tags } = val
        const prow = this.tData.data[index]
        prow[column.key] = str
        if (column.ids) {
          prow[column.ids] = ids
        }
        if (column.tagClose) {
          column.tagClose(index, prow, tags)
        }
      },
      clearSelectEdit (val) {
        const { index, row, column, select } = val
        const prow = this.tData.data[index]
        prow[column.key] = Array.isArray(select) ? [] : ''
        column.clear && column.clear(index, row, column)
      },
      inputChange (val) {
        const { index, column, text } = val
        const prow = this.tData.data[index]
        prow[column.key] = text
        column.change && column.change(index, prow, text)
      },
      datetimeChange (val) {
        const { index, column, text } = val
        const prow = this.tData.data[index]
        prow[column.key] = text
        column.change && column.change(index, prow, text)
      },
      decrypt (val) {
        const { index, column, text, row } = val
        this.tData.data[index][column.key] = text
        this.$emit('decrypt-success', row, column)
      },
      cellClick (row, column, cell, event) {
        this.$emit('cell-click', row, column, cell, event)
      },
      // 2021-08-24 排序，sortable 与elment字段排序规则保持一致
      sortChange (e) {
        this.$emit('sort-change', e)
      },
      showColumn (column, columnIndex) {
        const show = column.show
        const val = typeof show === 'function' ? show() : !(show === false)
        if (!this.visibleColumnMap) {
          this.visibleColumnMap = new Map()
        }
        val && this.visibleColumnMap.set(column.key, columnIndex)
        return val
      },
      // 是否显示单元格必填
      showCellRequired (column) {
        const showCellRequired = column.showCellRequired
        return typeof showCellRequired === 'function' ? showCellRequired() : showCellRequired === true
      },
      triggerEventManager (...args) {
        this.popoverManager.triggerEventManager(...args)
      }
    },
    created () {
      this.columnConfig = this.column
      this.toCatch(this.data)
      if (this.showIndex) {
        this.hIndex++
      }
      if (this.showCheckbox) {
        this.hIndex++
      }
      const handle = this.$slots.handle
      if (handle && Array.isArray(handle)) {
        this.hIndex += handle.reduce((c, i) => i.tag && i.tag.includes('ElTableColumn') ? c + 1 : c, 0)
      }
    },
    watch: {
      data (val) {
        this.toCatch(val)
      },
      column: {
        handler (val) {
          this.columnConfig = val
        },
        deep: true
      },
      status () {
        this.toChangeStatus()
        // 非编辑状态
        if (!this.status) {
          this.popoverManager && this.popoverManager.removePopperOfValidateSuccess()
        }
      },
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/public/components/kye-edit-table/index.vue